// src/app/slices/uiSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

type ThemeMode = 'light' | 'dark';

interface UiState {
    themeMode: ThemeMode;
}

// Read theme preference from localStorage, or use a default value
const getInitialTheme = (): ThemeMode => {
    const savedTheme = localStorage.getItem('themeMode');
    return (savedTheme === 'light' || savedTheme === 'dark') ? savedTheme : 'light';
};

const initialState: UiState = {
    themeMode: getInitialTheme(),
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setThemeMode: (state, action: PayloadAction<ThemeMode>) => {
            state.themeMode = action.payload;
            localStorage.setItem('themeMode', action.payload);
        },
        toggleThemeMode: (state) => {
            const newTheme = state.themeMode === 'light' ? 'dark' : 'light';
            state.themeMode = newTheme;
            localStorage.setItem('themeMode', newTheme);
        },
    },
});

export const { setThemeMode, toggleThemeMode } = uiSlice.actions;

export const selectThemeMode = (state: RootState) => state.ui.themeMode;

export default uiSlice.reducer;